import React from 'react';
import Helmet from 'react-helmet';
import { Query } from 'react-apollo';
import { useSelector } from 'react-redux';
import { Route, Switch, Redirect } from 'react-router-dom';
import Spin from 'components/common/Spin';
import { GET_STUDENT_PROFILE } from 'graphql/student/Profile';
import Tabs from './Tabs';
import GeneralInfo from './GeneralInfo';
import SchoolInfo from './SchoolInfo';
import CollegeInfo from './CollegeInfo';
import ParentsInfo from './ParentsInfo';
import NotificationsSettings from 'components/settings/Notifications';

const StudentProfile = ({
  editable = true,
  student,
  prefix,
  match: {
    params: { id },
  },
}) => {
  const user = useSelector((s) => s.user.user);
  prefix = prefix !== undefined ? prefix : `/students/${id}`;
  return (
    <Query
      query={GET_STUDENT_PROFILE}
      variables={{ id }}
      fetchPolicy={'cache-and-network'}
    >
      {({ data, loading, error }) => {
        if (loading) return <Spin spinning />;
        if (error) return 'Error';
        const profile = data.student_profile[0];
        if (!profile) return 'No profile found';

        return (
          <div>
            <Helmet title={`Profile`} />
            <Tabs userId={id} prefix={prefix} />
            <Switch>
              <Route
                path={`${prefix}/profile/general`}
                render={() => (
                  <GeneralInfo
                    editable={editable}
                    student={profile.user}
                    profile={profile}
                  />
                )}
              />
              <Route
                path={`${prefix}/profile/school`}
                render={() => (
                  <SchoolInfo
                    editable={editable}
                    student={student}
                    profile={profile}
                  />
                )}
              />
              <Route
                path={`${prefix}/profile/college`}
                render={() => (
                  <CollegeInfo
                    editable={editable}
                    student={student}
                    profile={profile}
                  />
                )}
              />
              <Route
                path={`${prefix}/profile/parents`}
                render={() => (
                  <ParentsInfo
                    editable={user.type === 'admin'}
                    student={student}
                    profile={profile}
                  />
                )}
              />
              <Route
                path={`${prefix}/profile/settings`}
                render={() => <NotificationsSettings user={student} editable={editable} />}
              />
              <Redirect
                path={`${prefix}/profile`}
                to={`${prefix}/profile/general`}
              />
            </Switch>
          </div>
        );
      }}
    </Query>
  );
};

export default StudentProfile;
